import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import './index.css';
import App from './App';


const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6Lfv2F4sAAAAAB4vlERb24LSvO7D5n3PhdyI4xa9';

const IS_DEV = process.env.NODE_ENV !== 'production';

// Suppress AbortError from Supabase internal promises (expected during async cleanup)
// This prevents the React error overlay from showing these expected errors
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.name === 'AbortError' ||
    event.reason?.message?.includes('signal is aborted')) {
    event.preventDefault();
    if (IS_DEV) console.log('Suppressed expected AbortError from Supabase');
  }
});

window.addEventListener('error', (event) => {
  if (event.message?.includes('AbortError') ||
    event.message?.includes('signal is aborted')) {
    event.preventDefault();
    if (IS_DEV) console.log('Suppressed expected AbortError from Supabase');
    return true;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
    <App />
  </GoogleReCaptchaProvider>
);


